import React from 'react';
import { useTranslation } from 'react-i18next';
import { LeaderboardEntry } from '../types';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { Avatar, AvatarFallback, AvatarImage } from '../../../components/ui/avatar';

interface LeaderboardListProps {
    entries: LeaderboardEntry[];
}

export const LeaderboardList: React.FC<LeaderboardListProps> = ({ entries }) => {
    const { t } = useTranslation('common');

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <Table>
                <TableHeader className="bg-gray-50">
                    <TableRow>
                        <TableHead className="w-[80px] text-center">{t('leaderboard.columns.rank')}</TableHead>
                        <TableHead>{t('leaderboard.columns.name')}</TableHead>
                        <TableHead className="text-right">{t('leaderboard.columns.points')}</TableHead>
                        <TableHead className="text-right">{t('leaderboard.columns.courses')}</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {entries.map((entry) => (
                        <TableRow key={entry.id} className="hover:bg-slate-50">
                            <TableCell className="font-bold text-center text-gray-500">
                                #{entry.rank}
                            </TableCell>
                            <TableCell>
                                <div className="flex items-center gap-3">
                                    <Avatar className="h-9 w-9 border border-gray-100">
                                        <AvatarImage src={entry.avatar} alt={entry.name} />
                                        <AvatarFallback className="bg-blue-50 text-blue-600 font-semibold">
                                            {entry.name[0]}
                                        </AvatarFallback>
                                    </Avatar>
                                    <span className="font-semibold text-gray-900">{entry.name}</span>
                                </div>
                            </TableCell>
                            <TableCell className="text-right font-bold text-blue-600">
                                {entry.points.toLocaleString()}
                            </TableCell>
                            <TableCell className="text-right text-gray-600 font-medium">
                                {entry.coursesCompleted}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
